import { j as l } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import * as s from "react";
import { c as o } from "../../chunks/index.CxSWpsOB.js";
const r = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("div", { className: "tw-relative tw-w-full", children: /* @__PURE__ */ l.jsx("table", { ref: t, className: o("tw-w-full tw-caption-bottom", a), ...e }) }));
r.displayName = "Table";
const d = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("thead", { ref: t, className: o("[&_tr]:tw-border-b", a), ...e }));
d.displayName = "TableHeader";
const m = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("tbody", { ref: t, className: o(a), ...e }));
m.displayName = "TableBody";
const w = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("tfoot", { ref: t, className: o("tw-border-t tw-font-medium [&>tr]:last:tw-border-b-0", a), ...e }));
w.displayName = "TableFooter";
const b = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("tr", { ref: t, className: o(a), ...e }));
b.displayName = "TableRow";
const c = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("th", { ref: t, className: o("tw-h-48 tw-px-16 tw-text-left tw-align-middle [&:has([role=checkbox])]:tw-pr-0", a), ...e }));
c.displayName = "TableHead";
const f = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("td", { ref: t, className: o("tw-p-16 tw-align-text-top", a), ...e }));
f.displayName = "TableCell";
const i = s.forwardRef(({
  className: a,
  ...e
}, t) => /* @__PURE__ */ l.jsx("caption", { ref: t, className: o("tw-mt-16", a), ...e }));
i.displayName = "TableCaption";
export {
  r as Table,
  m as TableBody,
  i as TableCaption,
  f as TableCell,
  w as TableFooter,
  c as TableHead,
  d as TableHeader,
  b as TableRow
};
//# sourceMappingURL=index.js.map
